/* import __COLOCATED_TEMPLATE__ from './complete.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
import { ProductName } from '@banking/ui/models/checking/product-positioning';
import countryTranslationKey from '@banking/ui/utils/checking/country-translation-key';
import productNameTranslationKey from '@banking/ui/utils/checking/product-name-translation-key';
import { tracked } from '@glimmer/tracking';
import { BalanceActivityEntityIdentifier, BalanceActivityType } from '@square/dashboard-protos/models/squareup/deposits/model';
export let CTA = /*#__PURE__*/function (CTA) {
  CTA[CTA["Default"] = 0] = "Default";
  CTA[CTA["Alternative"] = 1] = "Alternative";
  return CTA;
}({});
let Complete = (_class = class Complete extends Component {
  constructor(owner, args) {
    super(owner, args);
    _defineProperty(this, "CTA", CTA);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "userInfo", _descriptor2, this);
    _initializerDefineProperty(this, "externalDepositsApi", _descriptor3, this);
    _initializerDefineProperty(this, "isPauseSettlement", _descriptor4, this);
    _initializerDefineProperty(this, "transferFeeBasisPoints", _descriptor5, this);
    _initializerDefineProperty(this, "sentry", _descriptor6, this);
    const searchParams = new URLSearchParams(window.location.search);
    const unitToken = searchParams.get('unitToken') || this.userInfo.unitToken;
    try {
      this.externalDepositsApi.client.getDepositSchedule({
        unitToken
      }).then(res => {
        this.isPauseSettlement = res.currentWeeklyDepositSchedule.pausedSettlement;
      });
      this.externalDepositsApi.client.getTransferFeeDetails({
        sourceId: BalanceActivityEntityIdentifier.create({
          unitToken
        }),
        transferType: BalanceActivityType.INSTANT_PAYOUT
      }).then(res => {
        this.transferFeeBasisPoints = res.feeBasisPoints;
      });
    } catch (error) {
      this.sentry.captureException(error);
    }
  }
  get countryCode() {
    return this.userInfo.countryCode;
  }
  get transferSpeed() {
    switch (this.countryCode) {
      case 'CA':
        return this.intl.t('banking.checking.onboarding.complete.transferSpeed.CA');
      case 'GB':
        return this.intl.t('banking.checking.onboarding.complete.transferSpeed.GB');
      case 'US':
      default:
        return this.intl.t('banking.checking.onboarding.complete.transferSpeed.default');
    }
  }
  get transferAmountPercentage() {
    if (this.transferFeeBasisPoints) {
      return `${this.transferFeeBasisPoints / 100}%`;
    }
    return '';
  }
  get header() {
    return this.intl.t(productNameTranslationKey(this.args.productName, 'banking.checking.onboarding.complete.header'));
  }
  get description() {
    return this.intl.t(countryTranslationKey(Country[this.userInfo.countryCode], 'banking.checking.onboarding.complete.description'));
  }
  get subHeader() {
    if (!this.isPauseSettlement) {
      return this.intl.t('banking.checking.onboarding.complete.subHeader.automatic');
    } else {
      switch (this.args.productName) {
        case ProductName.CheckingAndDebit:
          return this.intl.t('banking.checking.onboarding.complete.subHeader.manual');
        default:
          return '';
      }
    }
  }
  get nextButtonCTA() {
    return this.intl.t(productNameTranslationKey(this.args.productName, 'banking.checking.onboarding.complete.nextButtonCTA'));
  }
  get salesToCheckingTitle() {
    switch (this.args.productName) {
      case ProductName.CheckingAndDebit:
        return this.intl.t('banking.checking.onboarding.complete.salesToChecking.title');
      default:
        return '';
    }
  }
  get buttons() {
    const buttons = [{
      rank: this.args.alternativeCTA ? 'secondary' : 'primary',
      text: this.nextButtonCTA,
      onClick: () => this.args.onNextButtonClick(this.CTA.Default)
    }];
    if (this.args.alternativeCTA) {
      buttons.push({
        rank: 'primary',
        text: this.args.alternativeCTA,
        onClick: () => this.args.onNextButtonClick(this.CTA.Alternative)
      });
    }
    return buttons;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "externalDepositsApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isPauseSettlement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "transferFeeBasisPoints", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Complete as default };